import React, { useState } from "react";

import { i18n } from "../../translate/i18n";
import CommentFeedFilterRail from "./components/CommentFeedFilterRail";
import PostFeedCard from "./components/PostFeedCard";
import InstagramPostModal from "./components/InstagramPostModal";

export default function SocialCommentsShell({
	postGroups,
	loading,
	error,
	channel,
	status,
	search,
	onChannelChange,
	onStatusChange,
	onSearchChange,
	onReply,
	onUpdateStatus,
	onLoadMoreComments,
	loadingMoreComments,
	setPage,
	hasMore,
}) {
	const [selectedGroup, setSelectedGroup] = useState(null);

	const openGroup =
		selectedGroup &&
		(postGroups.find((g) => g.post?.id === selectedGroup.post?.id) || selectedGroup);

	return (
		<div className="app-admin-page flex min-h-0 flex-1 flex-col" style={{ padding: "0.5rem" }}>
			<div className="card tailwick-chat-surface flex min-h-0 flex-1 flex-col overflow-hidden">
				<div className="flex min-h-0 min-w-0 flex-1 flex-col lg:flex-row">
					<CommentFeedFilterRail
						channel={channel}
						status={status}
						search={search}
						onChannelChange={onChannelChange}
						onStatusChange={onStatusChange}
						onSearchChange={onSearchChange}
					/>

					<div className="min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-contain p-3 sm:p-4">
						<div className="mx-auto flex w-full max-w-6xl flex-col gap-4 sm:gap-5">
							{loading && postGroups.length === 0 && (
								<p className="py-12 text-center text-sm text-default-500">
									{i18n.t("socialComments.loading")}
								</p>
							)}

							{error && (
								<p className="py-12 text-center text-sm text-danger">
									{i18n.t("socialComments.loadError")}
								</p>
							)}

							{!loading && !error && postGroups.length === 0 && (
								<p className="py-12 text-center text-sm text-default-500">
									{i18n.t("socialComments.emptyList")}
								</p>
							)}

							{!error && postGroups.length > 0 && (
								<div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3">
									{postGroups.map((group) => (
										<PostFeedCard
											key={group.post.id}
											group={group}
											onOpenComments={setSelectedGroup}
										/>
									))}
								</div>
							)}

							{!error && postGroups.length > 0 && hasMore && (
								<div className="flex justify-center py-4">
									<button
										type="button"
										onClick={() => setPage((prev) => prev + 1)}
										disabled={loading}
										className="btn btn-primary disabled:opacity-60"
									>
										{loading
											? i18n.t("socialComments.loading")
											: i18n.t("socialComments.loadMore")}
									</button>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>

			<InstagramPostModal
				open={Boolean(openGroup)}
				group={openGroup}
				onClose={() => setSelectedGroup(null)}
				onReply={onReply}
				onUpdateStatus={onUpdateStatus}
				onLoadMoreComments={onLoadMoreComments}
				loadingMoreComments={
					openGroup ? loadingMoreComments?.[openGroup.post.id] : false
				}
			/>
		</div>
	);
}
